<div class='e-btn-group' [formGroup]="form" [ngClass]="{
  'disabled': form.controls.formValue.disabled
}">
  @for (item of keyList; track item) {
    <input type="radio" [id]="id + '-' + fieldsEnum[item.value]" formControlName="formValue" [value]="item.value" title="button"/>
    <label class="e-btn d-flex align-items-center" [ngClass]="{'fixed-width': fixedWidth, 'inline': inline }" [for]="id + '-' + fieldsEnum[item.value]">{{ item.text | translate }}</label>
  }
</div>
